module.exports = __webpack_public_path__ + "static/project-crud-755d0b9e674f1fcd7861d86ceb085b93.jpg";